import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';

export const generateParagraphClassNames = ({
  style,
  extraClass,
  size,
  alignment,
}) => classNames(
  'paragraph',
  {
    [`paragraph--${style}`]: style,
    [`paragraph--${size}`]: size,
    [`text--${alignment}`]: alignment,
    [`${extraClass}`]: extraClass,
  },
);

const ParagraphContent = ({ enableBBCode, children }) => (
  enableBBCode ? <BBCodeParser>{children}</BBCodeParser> : children
);

ParagraphContent.propTypes = {
  children: PropTypes.node.isRequired,
  enableBBCode: PropTypes.bool,
};

const Paragraph = ({
  children,
  style,
  extraClass,
  size,
  alignment,
  enableBBCode = true,
  testAttribute,
}) => (
  <p
    data-test={testAttribute}
    className={generateParagraphClassNames({
    style,
    size,
    extraClass,
    alignment,
    })}
  >
    <ParagraphContent enableBBCode={enableBBCode}>
      {children}
    </ParagraphContent>
  </p>
);

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.string,
  extraClass: PropTypes.string,
  size: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'center', 'right']),
  enableBBCode: PropTypes.bool,
  testAttribute: PropTypes.string,
};

export default Paragraph;
